<template>
  <div>
    <b-button :id="`button-view-punch-card-campaign-${uuid}`" class="-view"
      @click="!detailsLoading ? handleViewPunchCardCampaign(uuid) : null" v-if="!source"></b-button>
    <b-button :id="`button-edit-punch-card-campaign-${uuid}`" class="-edit"
      @click="!detailsLoading ? handleEditPunchCardCampaign(uuid) : null" v-if="!source"></b-button>
    <b-button :id="`button-delete-punch-card-campaign-${uuid}`" class="-delete d-none"></b-button>
    <b-button :id="`button-download-punch-card-campaign-${uuid}`"
      :class="['-download', { 'd-none': !source }]"></b-button>
    <b-button :id="`button-print-punch-card-campaign-${uuid}`" class="-print"
      @click="!detailsLoading ? handleQRPunchCardCampaign(uuid) : null"></b-button>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: ["uuid", "source"],
  computed: {
    ...mapGetters("punchCard", ["errors", "detailsLoading"])
  },
  methods: {
    async handleViewPunchCardCampaign(uuid) {
      await this.$store.dispatch("punchCard/getPunchCardCampaignDetails", uuid);

      if (!this.errors) this.$root.$emit("openViewCampaign");
    },
    async handleEditPunchCardCampaign(uuid) {
      await this.$store.dispatch("punchCard/getPunchCardCampaignDetails", uuid);

      if (!this.errors) this.$root.$emit("openCampaignUpdate", uuid);
    },
    async handleQRPunchCardCampaign(uuid) {
      await this.$store.dispatch("punchCard/getPunchCardCampaignDetails", uuid);

      if (!this.errors) this.$root.$emit("openCampaignQR", uuid);
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  background-color: transparent;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border-color: #E9EBED;
  box-shadow: none !important;

  &:not(:last-child) {
    margin-right: 0.5rem;
  }

  &.-view {
    background: transparent url("~@/assets/images/icons/punch-card/view.svg") no-repeat center;
  }

  &.-edit {
    background: transparent url("~@/assets/images/icons/punch-card/edit.svg") no-repeat center;
  }

  &.-delete {
    background: transparent url("~@/assets/images/icons/punch-card/delete.svg") no-repeat center;
  }

  &.-download {
    background: transparent url("~@/assets/images/icons/punch-card/download.svg") no-repeat center;
  }

  &.-print {
    background: transparent url("~@/assets/images/icons/punch-card/print.svg") no-repeat center;
  }
}
</style>
